import { render } from "./json-builder-actions.vue?vue&type=template&id=52c03536"
import script from "./json-builder-actions.vue?vue&type=script&lang=js"
export * from "./json-builder-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__